
    <button [ngClass]="types">
      <icon [name]="icon"></icon> <ng-content></ng-content>
    </button>
  